import styled from "styled-components";

export const HomepageContainer = styled.div`
      display: flex;
      flex-direction: column;
      align-items: center;   
  
      & h1 {
        text-transform: uppercase;
     }
`